import { useDevice } from '../state/DeviceProvider.js';

/**
 * The connect/disconnect affordance, rendered unconditionally at the top of
 * every page. Extracted from `HomePage` in spec 0002 Stage 0 so sibling routes
 * share one control.
 *
 * Two states:
 * - disconnected — the connect prompt, with a phase-aware button label.
 * - connected — a summary bar with a Disconnect button. Before this,
 *   `SoluuDevice.disconnect()` existed but nothing called it: the gate returned
 *   null once connected, so closing the tab was the only way to drop the link.
 *
 * Per the spec's Stage 0 note, no page adds a second disconnect control.
 */
export function ConnectGate() {
  const ble = useDevice();

  if (ble.device) {
    return (
      <section className="section connect-bar">
        <div className="row connect-bar-row">
          <div className="connect-bar-identity">
            <span className="status-dot ok" aria-hidden="true" />
            <strong>{ble.device.name || 'Soluu'}</strong>
            {ble.status && (
              <span className={`label-pill label-${ble.status.label}`}>
                {ble.status.label}
              </span>
            )}
          </div>
          <button type="button" onClick={() => void ble.disconnect()}>
            Disconnect
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <h2>Connect to a Soluu</h2>
      <p className="muted">
        Click below and pick the device from the browser's Bluetooth chooser.
      </p>
      <div className="row">
        <button
          type="button"
          className="primary"
          onClick={() => void ble.connect()}
          disabled={ble.connecting}
        >
          {ble.phase === 'choosing'
            ? 'Waiting for chooser…'
            : ble.phase === 'connecting'
              ? 'Connecting to device…'
              : 'Connect to Soluu'}
        </button>
      </div>
      {ble.error && (
        <div className="banner error" style={{ marginTop: '1rem' }}>
          {ble.error}
        </div>
      )}
    </section>
  );
}
